import React, { forwardRef, useContext, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { TourContext } from "../context";
var useStyles = makeStyles(function (theme) {
  return {
    '@keyframes pulse': {
      from: {
        boxShadow: "0 0 0 2px ".concat(theme.palette.tour.beacon.background)
      },
      to: {
        boxShadow: "0 0 0 5px ".concat(theme.palette.tour.beacon.background)
      }
    },
    beaconTarget: {
      borderRadius: '6px',
      animation: '1s $pulse ease-in-out infinite alternate'
    }
  };
});
export var TourBeacon = /*#__PURE__*/forwardRef(function (_, ref) {
  var classes = useStyles();
  var _useContext = useContext(TourContext),
    currentActiveTourStep = _useContext.currentActiveTourStep,
    currentStepIndex = _useContext.currentStepIndex;

  /**
   * Applies a border around `currentStep`'s target and then
   * scrolls said target element into view if `Step.disableScrolling` is `false`.
   */
  useEffect(function () {
    var currentStep = currentActiveTourStep.steps[currentStepIndex];
    if (currentStep.disableBeacon) return null;
    var el = document.querySelector(currentStep.target);
    if (!el) return null;
    el.classList.add(classes.beaconTarget);
    if (!currentStep.disableScrolling) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
    return function () {
      if (!el) return;
      el.classList.remove(classes.beaconTarget);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  });
});
TourBeacon.displayName = 'TourBeacon';